import { Injectable } from '@angular/core';
import { PackageService } from '../packages/package.service';
import { TranslateService } from '../translate/translate.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class QueService {
  translations: any;

  constructor(private packageService: PackageService, private snackbar: SnackbarService, private ts: TranslateService, private http: HttpClient) {
    this.translations = this.ts.get('general');
  }

  public async triggerPriority(packageId: string): Promise<any> {
    const pak = await this.packageService.get(packageId);
    if (!!pak?.newWorker) {
      const res: any[] = [await this.http.get(`${environment.workerBaseUrl}package-cache/run/${packageId}`).toPromise()];
      if (!!pak.assignedChildPackages?.length) {
        res.concat(await Promise.all(pak.assignedChildPackages.map(id => this.http.get(`${environment.workerBaseUrl}package-cache/run/${id}`))));
      }
      const state = !res.find(res => !res?.result) ? 'success' : 'error';
      this.snackbar[state](this.translations['worker' + state.toUpperCase()], 5000);
    } else {
      await Promise.all([this.packageService.patch(packageId, { 'cache.queuePriorityDynamicContent': 1 })]
        .concat(pak.assignedChildPackages.map(id => this.packageService.patch(id, { 'cache.queuePriorityDynamicContent': 1 }))));
      this.snackbar.success(this.translations.queuePriorityDone, 5000);
    }
  }

  public async triggerPriorities(packageIds: string[]) {
    await Promise.all((!!Array.isArray(packageIds) ? packageIds : [packageIds]).map(id => this.triggerPriority(id)));
  }
}
